// Slow editorial marquee strip.
export const Marquee = ({ items, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="marquee" className={`overflow-hidden py-8 ${className}`}>
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl sm:text-6xl lg:text-7xl px-6 lg:px-10">
              {item}
            </span>
            <span className="text-rose text-3xl lg:text-5xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
